module.exports = __webpack_public_path__ + "static/img/colleges-bg.1b9fa7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/colleges-bg.png
// module id = 8WT6
// module chunks = 1